export const onChangeAndValidationPrice = (inputedValue, callBack) => {
  let isValidInput = true;
  const regex = /^\d+(?:\.\d{0,2})?$/;
  isValidInput = isValidInput && regex.test(inputedValue);
  if (isValidInput || !inputedValue) {
    if (callBack) callBack();
  }
};
